import { Grid } from '@mui/material';

import UploadedFile from '../UploadedFile';

import { UploadedFileContainerProps } from './props';

const UploadedFilesContainer = ({
  fileList = [],
  itemProps,
  onRemove,
  uploadedFileProps,
}: UploadedFileContainerProps) => {
  // ======================= EVENTS
  const getReadableFileSizeString = (fileSizeInBytes: number) => {
    let i = -1;
    const byteUnits = [' kb', ' mb', ' gb', ' tb', 'pb', 'eb', 'zb', 'yb'];
    do {
      fileSizeInBytes /= 1024;
      i++;
    } while (fileSizeInBytes > 1024);

    return Math.max(fileSizeInBytes, 0.1).toFixed(1) + byteUnits[i];
  };

  // ======================= VIEWS
  return (
    <Grid container spacing={2}>
      {fileList.map((file, i) => (
        <Grid item key={i} {...itemProps}>
          <UploadedFile
            file={file}
            fileName={file.name}
            fileSize={getReadableFileSizeString(file.size)}
            removeButtonProps={{
              onClick: () => onRemove?.(i),
            }}
            {...uploadedFileProps}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default UploadedFilesContainer;
